import React from 'react';
export function PainPointSection() {
  return <section className="w-full bg-sage py-16 px-4 flex flex-col items-center" data-id="element-63">
      <div className="max-w-3xl w-full text-center" data-id="element-64">
        <h2 className="text-3xl md:text-4xl font-bold text-brown-800 mb-8" data-id="element-65">
          Si todos los días terminás pensando qué cocinar, esto es para vos
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-brown-600 font-medium leading-relaxed" data-id="element-66">
          <p data-id="element-67">No porque cocines mal. No porque no quieras organizarte.</p>
          <p data-id="element-68">
            Sino porque decidir todos los días qué comprar, qué descongelar, qué
            mandar de vianda y cómo no gastar de más agota a cualquiera.
          </p>
          <p className="font-bold text-brown-800 text-xl md:text-2xl mt-8" data-id="element-69">
            El problema real no es cocinar. El problema es no tener un sistema.
          </p>
        </div>

        <div className="mt-12 flex justify-center" data-id="element-70">
          <a href="#compra" className="bg-gradient-to-r from-gold-400 to-gold-500 text-white font-bold text-lg py-4 px-8 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 inline-flex items-center justify-center gap-2 w-full max-w-md" data-id="element-71">
            🔓 QUIERO ORGANIZAR MIS COMIDAS HOY
          </a>
        </div>
      </div>
    </section>;
}